import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";
import { BLOCKING_REASONS } from "../../../pages/project/components/ApprovalDialog";

export const NotificationProjectBanned: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;

    const { t } = useTranslation();

    const info = actions?.[0]?.projectBannedInfo;

    if (!info) {
        return null;
    }

    const projectId = info?.projectId;
    const projectTitle = info?.projectTitle;
    const contexts = info?.contexts || [];
    const reasons = info?.reasons || [];

    const hasUnbanRequest = Array.isArray(contexts) && contexts.includes('unbanrequest');
    
    if (hasUnbanRequest) {
        return (
            <SimpleTitle>
                {t('notifications.project_banned_1')}
                <a href={CreateLinkTo.project(projectId)}>{projectTitle}</a>
                {t('notifications.project_under_review')}
            </SimpleTitle>
        );
    }
    
    const reasonsList = reasons
        .filter((reasonEnum: number) => reasonEnum !== 13)
        .map((reasonEnum: number) => {
            const reasonConfig = BLOCKING_REASONS.find(r => r.value === reasonEnum);
            return reasonConfig ? t(reasonConfig.labelKey) : null;
        })
        .filter(Boolean);

    const otherReasonText = info?.otherReason;
    if (reasons.includes(12) && otherReasonText) {
        const otherIndex = reasonsList.findIndex((text: string) => 
            text === t('project_edit.blocking_reason_other')
        );
        if (otherIndex !== -1) {
            reasonsList[otherIndex] = `${t('project_edit.blocking_reason_other')}: ${otherReasonText}`;
        }
    }

    if (reasonsList.length === 0) {
        return null;
    }

    const reasonsText = reasonsList.join(', ');

    return (
        <SimpleTitle>
            {t('notifications.project_banned_1')}
            <a href={CreateLinkTo.project(projectId)}>{projectTitle}</a>
            {t('notifications.project_banned_2')}{reasonsText}.
        </SimpleTitle>
    );
}

import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";
import { BLOCKING_REASONS } from "../../../pages/project/components/ApprovalDialog";

export const NotificationProjectBanned: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;

    const { t } = useTranslation();

    const info = actions?.[0]?.projectBannedInfo;

    if (!info) {
        return null;
    }

    const projectId = info?.projectId;
    const projectTitle = info?.projectTitle;
    const contexts = info?.contexts || [];
    const reasons = info?.reasons || [];

    const hasUnbanRequest = Array.isArray(contexts) && contexts.includes('unbanrequest');
    
    if (hasUnbanRequest) {
        return (
            <SimpleTitle>
                {t('notifications.project_banned_1')}
                <a href={CreateLinkTo.project(projectId)}>{projectTitle}</a>
                {t('notifications.project_under_review')}
            </SimpleTitle>
        );
    }
    
    const reasonsList = reasons
        .filter((reasonEnum: number) => reasonEnum !== 13)
        .map((reasonEnum: number) => {
            const reasonConfig = BLOCKING_REASONS.find(r => r.value === reasonEnum);
            return reasonConfig ? t(reasonConfig.labelKey) : null;
        })
        .filter(Boolean);

    const otherReasonText = info?.otherReason;
    if (reasons.includes(12) && otherReasonText) {
        const otherIndex = reasonsList.findIndex((text: string) => 
            text === t('project_edit.blocking_reason_other')
        );
        if (otherIndex !== -1) {
            reasonsList[otherIndex] = `${t('project_edit.blocking_reason_other')}: ${otherReasonText}`;
        }
    }

    if (reasonsList.length === 0) {
        return null;
    }

    const reasonsText = reasonsList.join(', ');

    return (
        <SimpleTitle>
            {t('notifications.project_banned_1')}
            <a href={CreateLinkTo.project(projectId)}>{projectTitle}</a>
            {t('notifications.project_banned_2')}{reasonsText}.
        </SimpleTitle>
    );
}

